import { createContext, useContext } from 'react';
import type { LoginResponse, User } from '../services/authService';

export interface UserPermissions {
  can_delete_projects?: boolean;
  can_access_admin?: boolean;
  can_manage_users?: boolean;
  can_create_projects?: boolean;
  can_edit_projects?: boolean;
  can_view_projects?: boolean;
  can_create_subprojects?: boolean;
  can_edit_subprojects?: boolean;
  can_delete_subprojects?: boolean;
  can_execute_searches?: boolean;
  can_use_ai_chatbot?: boolean;

  // RAG / document-scoped permissions
  can_prepare_rag?: boolean;
  can_view_documents?: boolean;
  
  // Knowledge base permissions
  can_create_knowledge_bases?: boolean;
  can_delete_knowledge_bases?: boolean;
}

export interface AuthContextType {
  isAuthenticated: boolean;
  user: User | null;
  permissions: UserPermissions;
  login: (username: string, password: string) => Promise<LoginResponse>;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
